export default __webpack_public_path__ + "static/media/plus_nav.59c3bbaa.svg";